/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Section_AiInputs */



/**
* | output |
* | --- |
* | "AI Tools" |
*
* @param {Signup_Compare_Section_AiInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_section_ai = /** @type {((inputs?: Signup_Compare_Section_AiInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Section_AiInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("AI Tools")
	if (locale === "de") return /** @type {LocalizedString} */ ("AI Tools")
	if (locale === "it") return /** @type {LocalizedString} */ ("AI Tools")
	if (locale === "ru") return /** @type {LocalizedString} */ ("AI Tools")
	if (locale === "es") return /** @type {LocalizedString} */ ("AI Tools")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AI Tools")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AI Tools")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AI Tools")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("AI Tools")
	return /** @type {LocalizedString} */ ("AI Tools")
});